var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "root" },
    [
      _c("div", { staticClass: "head" }, [_c("AdminMenu")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("Footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }